import { render, staticRenderFns } from "./OnboardingDetail.vue?vue&type=template&id=2af8ca77&"
import script from "./OnboardingDetail.vue?vue&type=script&lang=js&"
export * from "./OnboardingDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports